import { inject, Injectable } from '@angular/core';
import { AnalyticsEvent } from '../models/analytics-event.interface';
import { EventManagementApiService } from './event-management-api.service';
import { StorageService } from '@client-monorepo/common/utilities';
import { AnalyticsEventRequest } from '../models/analytics-event-request.interface';

@Injectable({
  providedIn: 'root',
})
export class EventManagementService {
  private eventManagementApiService = inject(EventManagementApiService);
  private events: AnalyticsEventRequest[] = [];
  private storageService = inject(StorageService);

  constructor() {
    setInterval(
      () => {
        this.sendEvents();
      },
      3 * 60 * 1000,
    );
  }

  private getNowDate(): string {
    const now = new Date();
    return now.toISOString();
  }

  addEventToQueue(event: AnalyticsEvent) {
    this.events.push(this.completeEventsData(event));
  }

  public triggerEventImmediately(event: AnalyticsEvent): void {
    this.events.push(this.completeEventsData(event));
    this.sendEvents();
  }

  private sendEvents(): void {
    if (this.events.length <= 0) {
      return;
    }
    const events = [...this.events];
    this.events = [];
    this.eventManagementApiService.triggerEvent(events).subscribe({});
  }

  private completeEventsData(event: AnalyticsEvent): AnalyticsEventRequest {
    return {
      ...event,
      userId: this.storageService.getUserId() || null,
      from: window.location.href,
      agent: window?.navigator?.userAgent || 'unknown',
      date: this.getNowDate(),
    };
  }
}
